import React from 'react';
import PropTypes from 'prop-types';
import DataContainer from 'Components/UI/DataContainer';
import OutflowsMoneyFlowsSection from './OutflowsMoneyFlowsSection';

export const OutflowsMoneyFlowsSectionContainer = ({ relationship }) => {
  const [resource, setResource] = React.useState(null);

  const fetchData = async (rel) => {
    const [sectionResource] = await rel.getRelated();
    setResource(sectionResource);
  };

  React.useEffect(() => {
    if (relationship) {
      fetchData(relationship);
    }
  }, [relationship]);


  return (
    <DataContainer
      component={OutflowsMoneyFlowsSection}
      componentProps={{
        resource,
      }}
      loading={!resource}
    />
  );
};

OutflowsMoneyFlowsSectionContainer.propTypes = {
  relationship: PropTypes.object.isRequired,
};
